import { TFunction } from 'i18next';
import { useLocation } from 'react-router-dom';
import { SimpleNavItemProps } from '@cp-shared-19/frontend-ui';
import { useContractsCountDropdown } from './contracts-count/useContractsCountDropdown';
import { useSortedContractsCount } from './contracts-count/useContractsCount';
import { dashboardPagePath } from './paths';

export function useDashboardNavItem(t: TFunction): SimpleNavItemProps {
    const { pathname } = useLocation();
    const dropdownItems = useContractsCountDropdown();
    const { isLoading, loadingError } = useSortedContractsCount();

    const label = t('navigation.dashboard');

    if (dropdownItems.length) {
        return { label, dropdownItems };
    }

    const isOnDashboard = pathname === dashboardPagePath();
    const dataReady = !isLoading && !loadingError;

    return {
        label,
        href: dashboardPagePath(),
        url: dashboardPagePath(),
        onClick: isOnDashboard && dataReady ? () => window.location.reload() : undefined,
    };
}
